import axiosInstance from "@/api/axiosInstance";
import {
  GetEventTransactionDetailsRequest,
  GetEventTransactionDetailsResponse,
} from "./types";

export const getEventTransactionDetails = async (
  requestData: GetEventTransactionDetailsRequest,
): Promise<GetEventTransactionDetailsResponse> => {
  const url = `/api/private/event-sessions/${requestData.uuid}/transactions`;

  const response =
    await axiosInstance.get<GetEventTransactionDetailsResponse>(url);

  return response.data;
};
